if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.overlay = this.querySelector('[data-overlay]');
        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
        this.overlay.addEventListener('click', () => {
          super.hide();
        })
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(`${location.origin}/products/${opener.getAttribute('data-product-url')}?view=quick-shop`)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('[data-quick-add-content]');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);

            this.setContentHeight()
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

    setContentHeight() {
        const drowerHeaderH = this.querySelector('[data-drawer-header]').offsetHeight ;
        const drowerFooterH = this.querySelector('[data-quick-buy-footer]').offsetHeight  ;
        const drowerTitleH          = this.querySelector('[data-drawer-title]').offsetHeight;
        const drowerContentH = parseInt(window.innerHeight - drowerFooterH - drowerHeaderH - drowerTitleH);
        document.documentElement.style.setProperty('--quick-buy-content-height', `${drowerContentH || 0}px`);
    }

      preprocessHTML(productElement) {
      }

    }
  );
}
